import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteConstants, RoutePermissionByRoleConstants, RoutingUseHash } from '@app/constants/route.constants';
import { AuthGuardService } from '@app/security/guards/authentication.guard';
import { AdministrationLayoutComponent } from '@layout/administration-layout/administration-layout.component';

const routes: Routes = [
  {
    path: RouteConstants.LOGIN,
    loadChildren: () => import('./modules/app-modules/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: RouteConstants.EMPTY,
    component: AdministrationLayoutComponent,
    canActivate: [AuthGuardService],
    // data: { roles: RoutePermissionByRoleConstants.xxxx},
    children: [
      {
        path: RouteConstants.CECOS,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.CECOS },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.SVA,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.SVA },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.SVB,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.SVB },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.USVA,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.USVA },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.USVB,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.USVB },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.FARMACS,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.FARMACS },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.ESCALES,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.ESCALES },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.INT,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.INT },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.HNT,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.HNT },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.PATHOPHYSIOLOGY,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.PATHOPHYSIOLOGY },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.GLOSSARY,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.GLOSSARY },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.procediments,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.procediments },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.codisActivacio,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.codisActivacio },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.ETHIC,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.ETHIC },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.MANUALS,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.LEGAL },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.ABREVIACIONS,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.ABREVIACIONS },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.USERS,
        canActivate: [AuthGuardService],
        data: { roles: RoutePermissionByRoleConstants.USERS },
        loadChildren: () => import('./modules/app-modules/administration/users/users.module').then((m) => m.UsersModule)
      },
      {
        path: RouteConstants.repositori,
        canActivate: [AuthGuardService],
        data: { view: RouteConstants.repositori },
        loadChildren: () => import('./modules/app-modules/content-list/content-list.module').then((m) => m.ContentListModule)
      },
      {
        path: RouteConstants.CONTACT,
        loadChildren: () => import('./modules/app-modules/contact/contact.module').then((m) => m.ContactModule)
      },
      {
        path: RouteConstants.OTHER,
        pathMatch: 'full',
        redirectTo: RouteConstants.INT
      }
    ]
  },
  {
    path: RouteConstants.OTHER,
    pathMatch: 'full',
    redirectTo: RouteConstants.EMPTY
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', useHash: RoutingUseHash })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
